import {attendeeApiClient} from 'attendee/apiClient'
import {FullPageLoader} from 'attendee/theme/FullPageLoader'
import {Invoice} from 'organization/Invoices/Invoices/OrganizationInvoicesProvider'
import React, {useEffect, useState} from 'react'

export interface AttendeeInvoicesContextProps {
  invoices: Invoice[]
  refresh: () => Promise<void>
}

export const AttendeeInvoicesContext = React.createContext<
  AttendeeInvoicesContextProps | undefined
>(undefined)

export default function AttendeeInvoicesProvider(props: {
  children: React.ReactElement
}) {
  const apiClient = attendeeApiClient()
  const [invoices, setInvoices] = useState<Invoice[]>([])
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    get()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const get = async () => {
    const response = await apiClient.get(`api/invoices`)
    setInvoices(response)
    setLoading(false)
  }

  const refresh = async () => {
    await get()
  }

  return (
    <AttendeeInvoicesContext.Provider
      value={{
        invoices,
        refresh,
      }}
    >
      {loading && <FullPageLoader />}
      {!loading && props.children}
    </AttendeeInvoicesContext.Provider>
  )
}

export function useAttendeeInvoices() {
  const context = React.useContext(AttendeeInvoicesContext)
  if (context === undefined) {
    throw new Error(
      'useAttendeeInvoices must be used within AttendeeInvoicesProvider',
    )
  }
  return context
}
